/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_DealsInputs */

const en_directory_footer_link_deals = /** @type {(inputs: Directory_Footer_Link_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount Codes`)
};

const zh_directory_footer_link_deals = /** @type {(inputs: Directory_Footer_Link_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`折扣码`)
};

/**
* | output |
* | --- |
* | "Discount Codes" |
*
* @param {Directory_Footer_Link_DealsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_deals = /** @type {((inputs?: Directory_Footer_Link_DealsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_DealsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_deals(inputs)
	return zh_directory_footer_link_deals(inputs)
});
export { directory_footer_link_deals as "directory.footer.link_deals" }